import * as React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { LazyFeatureBundleProvider } from '@/components/transition/lazy-feature-bundle-provider';

const SetProductModeContext = React.createContext();
SetProductModeContext.displayName = 'SetProductModeContext';

export const useSetProductMode = () => {
  const context = React.useContext(SetProductModeContext);

  if (!context) {
    throw new Error('useSetProductMode must be used within WebUiProvider');
  }

  return context;
};

export const WebUiProvider = ({
  initialProduct = 'voicetube',
  children,
}) => {
  const [productMode, setProductMode] = React.useState(initialProduct);
  const theme = React.useMemo(() => ({ product: productMode }), [productMode]);

  return (
    <SetProductModeContext.Provider value={setProductMode}>
      <ThemeProvider theme={theme}>
        <LazyFeatureBundleProvider>
          {children}
        </LazyFeatureBundleProvider>
      </ThemeProvider>
    </SetProductModeContext.Provider>
  );
};

WebUiProvider.propTypes = {
  children: PropTypes.node,
  initialProduct: PropTypes.oneOf(['voicetube', 'hero', 'vclass']),
};
